module.exports = {
  title: {
    tourTrash: 'Tour Trash',
    tourTrashDraft: 'Drafts List',
  },
  header: {
    button: {
      create: 'Create',
      publish: 'Publish',
    },
  },
  uploadImage: 'Upload image',
  tab: {
    detail: {
      title: 'Details',
      update: 'Update',
      create: 'Create',
      dragMessage: 'Draft image of Gift here',
      form: {
        time: {
          title: 'Time',
          startTimePlaceholder: 'Start time',
          endTimePlaceholder: 'End time',
          startDatePlaceholder: 'Start date',
          endDatePlaceholder: 'End date',
        },
        product: {
          title: 'Product',
          namePlaceholder: 'Name',
          descriptionPlaceholder: 'Description',
          legalPlaceholder: 'Legal',
          imagePathPlaceholder: 'Image path',
          videoTypePlaceholder: 'Video type',
          videoIdPlaceholder: 'Video ID',
        },
        setting: {
          title: 'Settings',
          frequency: 'Total number of reminders',
          notification: 'Notification setting',
          pushNotiToAll: 'All players receive push notifications',
          pushNotiToEligiblePlayers: 'Only Champion players receive push notifications',
          email: 'Email setting',
          sendEmailToAll: 'All players receive emails',
          sendEmailToEligiblePlayers: 'Only Champion players receive emails',
          participation: 'Membership participation setting',
          participationLevelZero: 'Free',
          participationLevelOne: 'Champion',
          participationLevelTwo: 'Legend',
          pushNotificationAtLaunch: 'Player receives notification at launch',
          sendEmailAtLaunch: 'Player receives email at launch',
          reminder: 'Reminders setting',
          reminderPushNotiPlaceholder: 'Remind before x (hour) push notification',
          reminderSendEmailPlaceholder: 'Remind before x (hour) send email',
          autoClose: 'Winner is automatically selected after closing date',
          autoCloseTooltip: 'After the Tour Trash ends, the system will automatically close and select the winner',
          autoClosePlaceholder: 'Set time x (hour) to automatically close',
        },
        name: {
          title: `Tour Trash's Name`,
          titlePlaceholder: 'Title',
          descriptionPlaceholder: 'Description',
          countries: 'Countries',
          loyaltyTier: 'Loyalty Tier',
        },
        validate: {
          titleBlank: 'Please input title.',
          countryBlank: 'Please select Country',
          descriptionBlank: 'Please input description.',
          startBeforeNow: 'The start date time must be after now.',
          endBeforeNow: 'The end date time must be after now.',
          startBeforeEnd: 'The start date must be before the end date time.',
          startTimeBlank: 'Please input start time.',
          endTimeBlank: 'Please input end time.',
          startDateBlank: 'Please input start date.',
          endDateBlank: 'Please input end date.',
          productNameBlank: 'Please input product name.',
          productDescriptionBlank: 'Please input product description.',
          productVideoTypeBlank: 'Please input product video type.',
          productVideoIdBlank: 'Please input product video id.',
          frequencyBlank: 'Please input push notifications reminder frequency.',
          loyaltyTierBlank: 'Please select at least one loyalty tier.',
        },
      },
    },
    player: {
      title: 'Players',
      table: {
        title: {
          index: 'No',
          name: 'Name',
          email: 'Email',
          level: 'Membership Level',
          enterDate: 'Enter Date',
          spentAmount: 'Spent Amount',
        },
        selectWinner: 'Select winner',
      },
      search: 'Search player',
      random: 'Random winner selection',
      placeholder: 'Email or name of player',
    },
  },
  message: {
    tourTrash: {
      update: 'Tour Trash successfully updated.',
      updateFail: 'Failed to update Tour Trash.',
      create: 'Tour Trash successfully created.',
      close: 'Tour Trash successfully closed.',
      closeFail: 'Failed to close Tour Trash.',
      cancel: 'Tour Trash successfully cancelled.',
      cancelFail: 'Failed to cancel Tour Trash.',
      activate: 'Tour Trash successfully activated.',
      activateFail: 'Failed to activate Tour Trash.',
      delete: 'Tour Trash successfully deleted.',
      deleteFail: 'Failed to delete Tour Trash.',
      archive: 'Tour Trash successfully archived.',
      archiveFail: 'Failed to archive Tour Trash.',
    },
    winner: {
      success: 'Winner successfully picked.',
      fail: 'Failed to pick a winner.',
    },
    random: {
      success: 'Winner successfully selected.',
      fail: 'Failed to select a winner.',
    },
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again.',
      requireUpload: 'Please upload an image!',
    },
  },
  table: {
    title: {
      index: 'No',
      status: 'Status',
      winner: 'Winner',
      email: `Winner's Email`,
      startDate: 'Start Date',
      endDate: 'End Date',
      action: 'Action',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      close: 'Close',
      cancel: 'Cancel',
      view: 'View',
      active: 'Activate Tour Trash',
      activeExist: 'A Tour Trash has been activated',
      archive: 'Archive',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this Tour Trash?',
      archive: 'Are you sure to archive this Tour Trash?',
      activateContent: 'Once activated, only the Tour Trash description can be updated.',
      activate: 'Do you want to continue to activate this Tour Trash?',
      cancel: 'Are you sure to cancel this Tour Trash?',
      close: 'Are you sure to close this Tour Trash?',
      confirmPassword: 'Please input your password to confirm.',
      edit: 'Are you sure to edit this Tour Trash?',
    },
  },
  editImage: {
    title: 'Edit Image',
  },
  form: {
    btnSubmit: 'Submit',
  },
};
